import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AccessDeniedComponent {}
